import { InstrumentTypeResponse } from "../../../codegen-api";
import { IPerpsMarket } from "../../../contexts/MarketInstrumentContext/useGetMarkets";
import { useMarkPriceWSS } from "../../../hooks/wss/useMarkPriceWSS";
import { getContractPriceStep } from "../../../utils/instruments";
import Price from "../Price";

interface IMarkPriceProps {
  perpInstrument?: IPerpsMarket;
}

function MarkPrice({ perpInstrument }: IMarkPriceProps) {
  const m = useMarkPriceWSS(
    perpInstrument
      ? {
          instrumentName: perpInstrument.instrument_name,
          asset: perpInstrument.underlying_asset,
          derivative: InstrumentTypeResponse.Perpetual,
        }
      : undefined
  );
  const markPrice = m?.mark_price || perpInstrument?.mark_price;
  const { price_precision } = getContractPriceStep(perpInstrument);

  return (
    <Price
      currentPrice={
        markPrice
          ? Number(Number(markPrice).toFixed(Math.max(price_precision, 2))) // format to correct decimals
          : undefined
      }
      precision={price_precision}
      asset={perpInstrument?.underlying_asset}
      isOptions={false}
    />
  );
}

export default MarkPrice;
